import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AppSettings } from 'src/app/core/common/app-settings';
import { OperacionEnum } from 'src/app/core/enums/operacion.enum';
import { DisplayService } from 'src/app/core/services/caso/display.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { DatePipe } from '@angular/common';
import { DisplayDto } from 'src/app/shared/models/caso/display/display-dto.model';
import { DisplayVo } from 'src/app/shared/models/caso/display/display-vo.model';

@Component({
  selector: 'vex-monitor-form',
  templateUrl: './monitor-form.component.html',
  styleUrls: ['./monitor-form.component.scss']
})

export class MonitorFormComponent implements OnInit {

  appSettings = AppSettings;
  form: FormGroup;
  displayService = inject(DisplayService);
  public operation: OperacionEnum;
  dto: DisplayDto = new DisplayDto();
  vo: DisplayVo;
  datepipe: DatePipe;

  constructor(private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private toastrService: ToastrService) {
    this.operation = data.operation;
    this.vo = data.entity;
    this.form = this.fb.group({
      nombre: ['', Validators.required],
      direccion: ['', Validators.required],
      codigo: ['']
    });
  }

  ngOnInit(): void {
    if (this.operation === OperacionEnum.update) {
      this.form.controls['nombre'].setValue(this.vo.nombre);
      this.form.controls['direccion'].setValue(this.vo.direccion);
      this.form.controls['codigo'].setValue(this.vo.codigo);
      this.form.controls['codigo'].disable();
      this.form.controls['direccion'].disable();
    }
  }

  save() {
    this.dto.nombre = this.form.value.nombre;
    this.dto.estado = false;

    switch (this.operation) {
      case OperacionEnum.create:
        this.displayService.persist(this.dto).subscribe(
          (result) => {
            if (result.status) {
              this.toastrService.success(result.message);
              this.dialogRef.close(true);
            } else {
              this.toastrService.warning(result.message);
            }
          },
          (error) => {
            this.toastrService.error(error.message);
          }
        );
        break;
      case OperacionEnum.update:
        this.displayService.update(this.vo.monitor_id, this.dto).subscribe(
          (result) => {
            if (result.status) {
              this.toastrService.success(result.message);
              this.dialogRef.close(true);
            } else
              this.toastrService.warning(result.message);
          },
          (error) => {
            this.toastrService.error(error.message);
          }
        );
        break;
    }
  }

}
